export const TAG_FILTER = 'tag'
export const NAME_FILTER = 'name'
export const TAG_SEPARATOR = ':::'
